import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import {connect} from 'store';
import {loadElementList} from 'store/element-list/actions';
import * as uiActions from 'store/ui/actions';
import * as configActions from 'store/config/actions';
import Dialog from 'components/layout/dialog';
import {Section, Field, HelpText, Toggle, Select} from 'components/forms';

export class Settings extends Component {
    static propTypes = {
        opened: PropTypes.bool.isRequired,
        config: ImmutablePropTypes.map.isRequired,
        elementListLanguage: PropTypes.string.isRequired,
        elementListLoading: PropTypes.bool.isRequired,
        setLanguage: PropTypes.func.isRequired,
        toggleTranscript: PropTypes.func.isRequired,
        toggleCaptions: PropTypes.func.isRequired,
        toggleHeatmap: PropTypes.func.isRequired,
        toggleSpeakers: PropTypes.func.isRequired,
        toggleWordHighlight: PropTypes.func.isRequired,
        toggleSettings: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.opened !== this.props.opened
            || nextProps.config !== this.props.config
            || nextProps.elementListLanguage !== this.props.elementListLanguage
            || nextProps.elementListLoading !== this.props.elementListLoading
            || nextProps.setLanguage !== this.props.setLanguage
            || nextProps.toggleTranscript !== this.props.toggleTranscript
            || nextProps.toggleCaptions !== this.props.toggleCaptions
            || nextProps.toggleHeatmap !== this.props.toggleHeatmap
            || nextProps.toggleSpeakers !== this.props.toggleSpeakers
            || nextProps.toggleWordHighlight !== this.props.toggleWordHighlight
            || nextProps.toggleSettings !== this.props.toggleSettings;
    }

    render() {
        const {config, elementListLoading, elementListLanguage} = this.props;
        const language = config.get('language');
        const transcriptEnabled = config.get('transcriptEnabled');
        const heatmapEnabled = config.get('heatmapEnabled');
        const captionsEnabled = config.get('captionsEnabled');
        const elementListMessage = !elementListLoading && elementListLanguage !== language
            ? i18next.t('There is no transcript available in the selected language.')
            : '';

        return (
            <div className='cielo24-vwrap-settings'>
                <button
                    type='button'
                    className={classNames('cielo24-vwrap-toggle', {'cielo24-vwrap-opened': this.props.opened})}
                    onClick={this.props.toggleSettings}
                    title={i18next.t('Settings')}
                    aria-label={i18next.t('Settings')}
                >
                    <i aria-hidden={true} className='cielo24-vwrap-icon cielo24-vwrap-icon-settings' />
                </button>
                <Dialog title={i18next.t('Settings')} opened={this.props.opened} onClose={this.props.toggleSettings}>
                    <Section>
                        <Field label={i18next.t('Language')}>
                            <Select
                                value={config.get('language')}
                                options={config.get('languages')}
                                onChange={this.props.setLanguage}
                            />
                        </Field>
                        {elementListMessage && <HelpText>{elementListMessage}</HelpText>}
                    </Section>
                    {transcriptEnabled && (
                        <Section>
                            <Field label={i18next.t('Show Transcript')}>
                                <Toggle
                                    value={config.get('transcriptVisible')}
                                    onChange={this.props.toggleTranscript}
                                />
                            </Field>
                        </Section>
                    )}
                    {captionsEnabled && (
                        <Section>
                            <Field label={i18next.t('Show Captions')}>
                                <Toggle
                                    value={config.get('captionsVisible')}
                                    onChange={this.props.toggleCaptions}
                                />
                            </Field>
                        </Section>
                    )}
                    {heatmapEnabled &&
                        <Section>
                            <Field label={i18next.t('Show Heatmap')}>
                                <Toggle
                                    value={config.get('heatmapVisible')}
                                    onChange={this.props.toggleHeatmap}
                                />
                            </Field>
                        </Section>
                    }
                    {transcriptEnabled && (
                        <Section>
                            <Field label={i18next.t('Show Speakers in Transcript')}>
                                <Toggle
                                    value={config.get('speakersVisible')}
                                    onChange={this.props.toggleSpeakers}
                                />
                            </Field>
                        </Section>
                    )}
                    {config.get('wordHighlightOption') && (
                        <Section>
                            <Field label={i18next.t('Karaoke-style Word Highlighting')}>
                                <Toggle
                                    value={config.get('wordHighlight')}
                                    onChange={this.props.toggleWordHighlight}
                                />
                            </Field>
                        </Section>
                    )}
                    <div className='cielo24-vwrap-version'>
                        version: {VWRAP.version}
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    opened: state.ui.get('settingsOpened'),
    config: state.config,
    elementListLanguage: state.elementList.get('language'),
    elementListLoading: state.elementList.get('loading'),
});

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        toggleSettings: uiActions.toggleSettings,
        ...configActions,
    }, dispatch),
    setLanguage: (language) => {
        dispatch(configActions.setLanguage(language));
        dispatch(loadElementList());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./scripts/components/footer/settings.js